import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function JournalVeillePage() {
  const nav = useNavigate();

  useEffect(() => {
    // Redirect to TSV dashboard which has the journal tab
    nav('/telesurveillance', { replace: true, state: { tab: 'journal' } });
  }, [nav]);

  return null;
}
